var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { I18N } from "aurelia-i18n";
import { transient, autoinject } from "aurelia-framework";
import moment from "moment";
var RemainingTimeValueConverter = /** @class */ (function () {
    function RemainingTimeValueConverter(i18n) {
        this.i18n = i18n;
    }
    RemainingTimeValueConverter.prototype.toView = function (value) {
        if (!value)
            return "";
        var now = new Date();
        var end = new Date(value);
        // get total seconds between the times
        var delta = Math.abs(end - now) / 1000;
        // calculate (and subtract) whole days
        var days = Math.floor(delta / 86400);
        delta -= days * 86400;
        // calculate (and subtract) whole hours
        var hours = Math.floor(delta / 3600) % 24;
        delta -= hours * 3600;
        // calculate (and subtract) whole minutes
        var minutes = Math.floor(delta / 60) % 60;
        var daysStr = this.addZero(days);
        var hoursStr = this.addZero(hours);
        var minutesStr = this.addZero(minutes);
        var local = moment.localeData();
        var dd = local._relativeTime.dd;
        var hh = local._relativeTime.hh;
        var mm = local._relativeTime.mm;
        var html = '<div class="digits column">';
        html += '<div class="row nowrap">';
        html += "<span class=\"digit\">".concat(daysStr[0], "</span>");
        html += "<span class=\"digit\">".concat(daysStr[1], "</span>");
        html += '</div>';
        html += "<span class=\"label\">".concat((typeof (dd) == "function" ? dd(10, false, "dd") : dd).substr(3), "</span>");
        html += '</div>';
        html += '<div class="digits column">';
        html += '<div class="row nowrap">';
        html += "<span class=\"digit\">".concat(hoursStr[0], "</span>");
        html += "<span class=\"digit\">".concat(hoursStr[1], "</span>");
        html += '</div>';
        html += "<span class=\"label\">".concat((typeof (hh) == "function" ? hh(10, false, "hh") : hh).substr(3), "</span>");
        html += '</div>';
        html += '<div class="digits column">';
        html += '<div class="row nowrap">';
        html += "<span class=\"digit\">".concat(minutesStr[0], "</span>");
        html += "<span class=\"digit\">".concat(minutesStr[1], "</span>");
        html += '</div>';
        html += "<span class=\"label\">".concat((typeof (mm) == "function" ? mm(10, false, "mm") : mm).substr(3), "</span>");
        html += '</div>';
        return html;
    };
    RemainingTimeValueConverter.prototype.addZero = function (num) {
        if (num <= 9) {
            return "0" + num;
        }
        return num.toString();
    };
    RemainingTimeValueConverter = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [I18N])
    ], RemainingTimeValueConverter);
    return RemainingTimeValueConverter;
}());
export { RemainingTimeValueConverter };
